var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-partner"},[_c('p',[_vm._v(" View your Partner dashboard for insights into your collections. Explore formats, unique holdings and rights and re-use statements by clicking on the tabs at the bottom of the page. ")]),_c('router-link',{attrs:{"to":_vm.dashboardRoute}},[_vm._v("View Dashboard")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }